/* eslint-disable react/no-unescaped-entities,react/no-array-index-key */

import React from 'react';
import './PortalOLPromoBlock.scss';
import unsw from './ThirdPartyLogos/unsw.png';
import malaysiamoocs from './ThirdPartyLogos/malaysiamoocs.png';
import mmhe from './ThirdPartyLogos/mmhe.png';
import guokr from './ThirdPartyLogos/guokr.png';
import austrade from './ThirdPartyLogos/austrade.png';
import OpenLearningLogo from './OpenLearningLogo.png';

export const PortalOLPromoBlock = function () {
  const thirdPartyLogos = [unsw, guokr, mmhe, malaysiamoocs, austrade];

  return (
    <portal-ol-promo-block>
      <div className="row portal-section">
        <div className="columns small-11 small-centered medium-10 medium-centered">
          <div className="promo-block-wrapper">
            <div className="open-learning-logo">
              <img alt="" src={OpenLearningLogo} aria-hidden="true" />
            </div>
            <h5>
              Learn.com.au is owned and operated by OpenLearning.com, an online
              social learning platform. OpenLearning's unique social and
              interactive approach to learning has been adopted with great
              success by leading institutions and government bodies around the
              world.
            </h5>
            <div className="third-party-logos">
              {thirdPartyLogos.map((logoImage, i) => (
                <img alt="" src={logoImage} key={i} aria-hidden="true" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </portal-ol-promo-block>
  );
};
PortalOLPromoBlock.displayName = 'PortalOLPromoBlock';
